<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item" v-if="visible('Usuarios')">
        <sidenav-item url="/users" :class="getRoute() === 'users' ? 'active' : ''" navText="Usuarios">
          <template v-slot:icon>
            <i class="ni ni-badge text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="visible('Página web')">
        <sidenav-item url="/dashboard-default" :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          navText="Página web">
          <template v-slot:icon>
            <i class="ni ni-tag text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="visible('Libramientos')">
        <sidenav-item url="/bypasses" :class="getRoute() === 'bypasses' ? 'active' : ''" navText="Libramientos">
          <template v-slot:icon>
            <i class="ni ni-map-big text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="visible('Slider')">
        <sidenav-item url="/slider" :class="getRoute() === 'slider' ? 'active' : ''" navText="Slider">
          <template v-slot:icon>
            <i class="ni ni-image text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="visible('Documentos')">
        <sidenav-item url="/documents" :class="getRoute() === 'documents' ? 'active' : ''" navText="Documentos">
          <template v-slot:icon>
            <i class="ni ni-archive-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="visible('Galerias')">
        <sidenav-item url="/galleries" :class="getRoute() === 'galleries' ? 'active' : ''" navText="Galerias">
          <template v-slot:icon>
            <i class="ni ni-collection text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="visible('Comentarios')">
        <sidenav-item url="/comments" :class="getRoute() === 'comments' ? 'active' : ''" navText="Comentarios">
          <template v-slot:icon>
            <i class="ni ni-chat-round text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="visible('Alertas')">
        <sidenav-item url="/alerts" :class="getRoute() === 'alerts' ? 'active' : ''" navText="Alertas">
          <template v-slot:icon>
            <i class="ni ni-notification-70 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="visible('Incidencias')">
        <sidenav-item url="/incidences" :class="getRoute() === 'incidences' ? 'active' : ''" navText="Incidencias">
          <template v-slot:icon>
            <i class="ni ni-bulb-61 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="visible('Encuestas')">
        <sidenav-item url="/surveys" :class="getRoute() === 'surveys' ? 'active' : ''" navText="Encuestas">
          <template v-slot:icon>
            <i class="ni ni-square-pin text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
</template>

<script>
import SidenavItem from "./SidenavItem.vue";
import { mapGetters } from "vuex";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Vue Dashboard",
      controls: "dashboardsExamples",
      isActive: "active",
    };
  },
  components: {
    SidenavItem,
    //SidenavCard
  },
  computed: {
    ...mapGetters('auth', ["getUserRol"]),
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    visible(tabName) {
      switch (tabName) {
        case "Página web":
          if (this.getUserRol === 'Administrador' || this.getUserRol === 'Panel Web')
            return true
          else
            return false
        case "Libramientos":
          if (this.getUserRol === 'Administrador' || this.getUserRol === 'Panel Web')
            return true
          else
            return false
        case "Slider":
          if (this.getUserRol === 'Administrador' || this.getUserRol === 'Panel Web')
            return true
          else
            return false
        case "Documentos":
          if (this.getUserRol === 'Administrador' || this.getUserRol === 'Panel Web')
            return true
          else
            return false
        case "Galerias":
          if (this.getUserRol === 'Administrador' || this.getUserRol === 'Panel Web')
            return true
          else
            return false
        case "Usuarios":
          if (this.getUserRol === 'Administrador')
            return true
          else
            return false
        case "Comentarios":
          if (this.getUserRol === 'Administrador')
            return true
          else
            return false
        case "Alertas":
          if (this.getUserRol === 'Administrador' || this.getUserRol === 'Panel Auxilio Vial')
            return true
          else
            return false
        case "Incidencias":
          if (this.getUserRol === 'Administrador' || this.getUserRol === 'Panel Auxilio Vial')
            return true
          else
            return false
        case "Encuestas":
          if (this.getUserRol === 'Administrador')
            return true
          else
            return false
      }

    }
  },
};
</script>
